module.exports = __webpack_public_path__ + "img/google-play-store-logo.2d62b748.png";